//order of elements in Priorities matter as Linear maps No Priority to 0, Urgent to 1, High to 2, Medium to 3, Low to 4
export enum Priorities {
  NOPRIORITY = "No Priority",
  URGENT = "Urgent",
  HIGH = "High",
  MEDIUM = "Medium",
  LOW = "Low",
}

export const LinearLabels = ["bug", "my.hackthenorth.com"];

export interface Attachment {
  previewUrl: string;
  file: File;
}

export interface FormFields {
  title: string;
  userDescription: string;
  attachments: Attachment[];
  reporter: string;
  priority: Priorities;
}

export type ActionFields = "reset" | "removeAttachments";
